export default {
  MENU: 'menu'
};
